<template>
  <div class="shedDisplay-box">
    <div class="shedDisplay-top">
      <h5 class="title">外界环境参数</h5>
      <p>温度：{{weatherData.temperature}}℃</p>
      <p>湿度：{{weatherData.humidity}}%</p>
      <p>风力：{{weatherData.windpower}}【级】</p>
      <p>风向：{{weatherData.winddirection}}</p>
    </div>
    <div class="shedDisplay-wrap">
      <div class="container">
        <img class="bg" src="../../assets/qzyz/2.png" alt="" />
        <div class="pins-wrapper">
          <div class="row" v-for="(element, i) in listTemp" :key="i">
            <div
              :class="['pin', { hide: !item.posName }]"
              v-for="(item, index) in element"
              :key="index"
            >
              <van-popover
                v-model="item.showPopover"
                trigger="click"
                placement="top"
                @open="openFn(item)"
                @close="closeFn(item)"
              >
                <div class="details-pop" style="padding: 1.13vw 2.13vw">
                  <h3
                    style="color: #127be4; font-size: 3.2vw; line-height: 6.4vw"
                  >
                    {{ item.posName }}
                  </h3>
                  <p style="line-height: 6.4vw; font-size: 3.2vw">
                    温度：{{ item.warm }}℃
                  </p>
                  <p style="line-height: 6.4vw; font-size: 3.2vw">
                    湿度：{{ item.wet }}%
                  </p>
                  <p style="line-height: 6.4vw; font-size: 3.2vw">
                    CO2浓度：{{ item.co2 }}ppm
                  </p>
                  <p style="line-height: 6.4vw; font-size: 3.2vw">
                    风速：{{ item.air }}m/s
                  </p>
                </div>
                <template #reference>
                  <p class="text">{{ item.warm !=='0.00' ? item.warm : item.co2 }}</p>
                  <img
                    class="icon"
                    v-show="item.warnType === 0 && !item.openStatus"
                    src="../../assets/qzyz/3.png"
                    alt=""
                  />
                  <img
                    class="icon"
                    v-show="item.openStatus"
                    src="../../assets/qzyz/5.png"
                    alt=""
                  />
                  <img
                    class="icon"
                    v-show="item.warm === 1 && !item.openStatus"
                    src="../../assets/qzyz/4.png"
                    alt=""
                  />
                </template>
              </van-popover>
            </div>
          </div>
        </div>
      </div>
      <div class="shedDisplay-bottom">
        <div>
          <p>日龄：{{factor.age}}</p>
          <p>目标温度：{{factor.swarm}}℃</p>
          <!-- <p>热应激指数：102</p> -->
        </div>
      </div>
      <div class="detailed-box">
        <h3 class="title">当前棚舍{{ title }}</h3>
        <div class="data-box">
          <div class="data-wrap">
            <div class="data-item left">
              <img src="../../assets/qzyz/c.png" />
              <span>平均温度：{{ averageData.warm }}°C</span>
            </div>
            <div class="data-item">
              <img src="../../assets/qzyz/s.png" />
              <span>平均湿度：{{ averageData.wet }}%</span>
            </div>
          </div>
          <div class="data-wrap">
            <div class="data-item left">
              <img src="../../assets/qzyz/co2.png" />
              <span>平均CO2浓度：{{ averageData.co2 }}ppm</span>
            </div>
            <div class="data-item">
              <img src="../../assets/qzyz/f.png" />
              <span>平均风速：{{ averageData.air }}m/s</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { pointList, shedList,farmWeather } from "@/api/resetApi.js";
export default {
  data() {
    return {
      arr: [],
      title: "",
      averageData: {},
      weatherData:{},
      factor:{}
    };
  },
  computed: {
    listTemp: function () {
      let arrTemp = [];
      const channels = this.arr
        .reduce((result, item) => {
          if (!result.includes(item.channelId)) {
            result.push(item.channelId);
          }
          return result;
        }, [])
        .sort((a, b) => b - a);
      const colMap = {
        前: 0,
        中: 1,
        后: 2,
      };
      const resMap = this.arr.reduce((result, item) => {
        const col = colMap[item.posName.slice(-1)];
        result[`${item.channelId}-${col}`] = item;
        return result;
      }, {});
      let count = 3;
      for (let i = 0; i < count; i++) {
        arrTemp[i] = [];
        for (let j = 0; j < count; j++) {
          const item = resMap[`${channels[i]}-${j}`];
          if (item) {
            arrTemp[i].push(item);
          } else {
            arrTemp[i].push({ hide: true, openStatus: false });
          }
        }
      }
      return arrTemp;
    },
  },
  created() {
    if (this.$route.query.shedId && this.$route.query.uToken) {
      localStorage.setItem('uToken', this.$route.query.uToken)
      this.list();
      this.shedList();
      this.farmWeather()
    }
  },
  mounted(){
    document.getElementsByTagName("body")[0].style.backgroundColor = '#00214B'
  },
  beforeDestroy(){
    document.getElementsByTagName("body")[0].style.backgroundColor = ''
  },
  methods: {
    async list() {
      let res = await pointList({ 
        shedId: this.$route.query.shedId
      });
      if (res.data.code == 200) {
        res.data.data.sensor.forEach((item) => {
          item.openStatus = false;
        });
        this.title = res.data.data.sensor[0].shedName;
        this.arr = res.data.data.sensor;
        this.factor = res.data.data.factor || {}
        this.factor.swarm = this.factor.swarm ? this.factor.swarm.toFixed(1) : ''
      }
    },
    async shedList() {
      let res = await shedList();
      if (res.data.code == 200) {
        let list = res.data.data.filter((item) => {
          return item.shedId == this.$route.query.shedId;
        });
        this.averageData = list[0];
      }
    },
    async farmWeather() {
      let res = await farmWeather();
      if (res.data.code == 200) {
        this.weatherData = res.data.data
      }
    },
    openFn(item) {
      item.openStatus = true;
    },
    closeFn(item) {
      item.openStatus = false;
    },
  },
};
</script>
<style scoped lang="scss">
.shedDisplay-box {
  font-size: 0;
  .shedDisplay-top{
    color: white;
    text-align:left;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    padding: 9vw 8vw;
    .title{
      font-size: 3.73vw;
      padding: 3vw 0;
    }
    p{
      font-size:3.2vw;
      line-height: 1.5;
    }
  }
  .shedDisplay-bottom{
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: white;
    display: flex;
    justify-content: right;
    padding: 0vw 8vw 9vw;
    p{
      font-size:3.2vw;
      line-height: 1.5;
      text-align: left;
    }
  }
  .bg-img {
    max-width: 100%;
    height: 100%;
  }
  .shedDisplay-wrap {
    position: absolute;
    top: 30vw;
    padding-bottom: 4vw;
    width: 100%;
    .container {
      position: relative;
      .bg {
        display: block;
        width: 96.53vw;
        margin: 0 auto 0vw;
      }
      .pins-wrapper {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 59%;
        left: 45%;
        width: 49%;
        height: 34%;
        transform: rotate(-22deg) skew(31deg, 0deg) translate(5%, -105%);
      }
      .row {
        display: flex;
        flex: 1;
      }
      .pin {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        transform: skew(-31deg, 0deg) rotate(22deg);
        flex: 1;
      }
      .pin .text {
        position: absolute;
        top: -3.8vw;
        left: 4vw;
        line-height: 1.2;
        background: linear-gradient(315deg, #096fcb, #2784f8);
        min-width: 9.07vw;
        border-radius: 1.07vw;
        font-size: 3.2vw;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: justify;
        color: #ffffff;
        text-align: center;
      }
      .pin .icon {
        width: 45%;
      }
      .hide {
        visibility: hidden;
      }
    }
  }
  .detailed-box {
    width: 92.65vw;
    height: 38.13vw;
    background-image: url("~@/assets/qzyz/1.png");
    background-size:contain;
    background-repeat: no-repeat;
    margin: 0 auto;
    .title {
      font-size: 4.8vw;
      font-family: PingFangSC, PingFangSC-Semibold;
      font-weight: 600;
      text-align: justify;
      color: #ffffff;
      line-height: 8vw;
      text-align: center;
    }
    .data-box {
      padding-top: 6.27vw;
      .data-wrap {
        display: flex;
        padding-bottom: 4vw;
        // justify-content: space-around;
      }
      .data-item {
        display: flex;
        align-items: center;
        // flex: 1;
        img {
          width: 6.4vw;
          height: 6.4vw;
          margin-right: 1vw;
        }
        font-size: 3.2vw;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #181818;
        line-height: 1.2;
      }
      .left{
          padding-left: 4vw;
          width: 54%;
      }
    }
  }
}
</style>